export class VAT {
  private static legacyValue = 17;
  private static changedValue = 18;
  private static vatChangeDate = new Date(process.env.REACT_APP_VAT_CHANGE_DATE);

  static percents(date = new Date()) {
    return (date < this.vatChangeDate) ? this.legacyValue : this.changedValue;
  }

  static toString(date = new Date()) {
    return `${VAT.percents(date)}%`;
  }

  static fraction(date = new Date()) {
    return VAT.percents(date) / 100;
  }
}